import * as Oidc from 'oidc-client';

export const PortaInit = async () => {
  // Set the OpenID Connect authority URL
  const oidcAuthorityUrl = 'https://login.cncenter.cz/';

  // Get the current webpage URL
  const currentPageUrl = window.location.href;

  // Define client IDs for authentication based on webpage URL
  const clientId = 'a0b6aac5-c7b9-46c5-ba1c-698ce9b531dc'; //Tento klic dostavame od porty a je primo jenom pro isport

  // Set the redirect URI after successful authentication
  const redirectUri = `https://isport.blesk.cz/prihlaseni/login/porta?redirect_uri=${encodeURIComponent(currentPageUrl + (currentPageUrl.includes('?') ? '&' : '?') + 'loginType=GoogleOneTap')}`;

  // Define client ID for authentication
  const dataclientId = '724554886791-45p9r05mklnbvama9srjsu614uis17vg.apps.googleusercontent.com'; //Master key from Google Develop console

  // Specify the response type for authentication
  const responseType = 'code';

  // Define the scope of requested user information and access
  const scope = 'cnc.myaccount offline_access openid email profile';

  // Create a new instance of the Oidc.UserManager with provided settings
  const userManager = new Oidc.UserManager({
    authority: oidcAuthorityUrl,
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: responseType,
    scope: scope,
  });

  let generatedUrl;

  // Create a signin request using the userManager
  const signinRequest = await userManager.createSigninRequest();

  // Check if url exists in response
  if (signinRequest?.url) {
    // Parse the URL of the signin request
    const url = new URL(signinRequest?.url);
    // Get the params of the parsed url
    const params = new URLSearchParams(url.search.substring(1));

    generatedUrl =
      oidcAuthorityUrl +
      'ExternalLogin/ExternalLogin?provider=Google&returnUrl=' +
      encodeURIComponent(
        '/connect/authorize/callback?client_id=' +
          clientId +
          '&redirect_uri=' +
          redirectUri +
          '&response_type=' +
          responseType +
          '&scope=' +
          scope +
          '&state=' +
          params.get('state') +
          '&code_challenge=' +
          params.get('code_challenge') +
          '&code_challenge_method=' +
          params.get('code_challenge_method') +
          '&response_mode=' +
          params.get('response_mode')
      );
  }

  // Create a div element for Google Sign-In configuratio
  const googleDiv: HTMLDivElement = document.createElement('div');
  googleDiv.id = 'g_id_onload';
  googleDiv.setAttribute('data-client_id', dataclientId);
  googleDiv.setAttribute('data-login_uri', generatedUrl || '');
  googleDiv.setAttribute('data-cancel_on_tap_outside', 'false');

  document.body.appendChild(googleDiv);

  // Create a script element for Google Sign-In
  const googleScript: HTMLScriptElement = document.createElement('script');
  googleScript.src = 'https://accounts.google.com/gsi/client';
  googleScript.async = true;
  googleScript.defer = true;

  // Append the script element to the document's head
  document.body.appendChild(googleScript);
};
